export type PuzzleDifficultyKey = "easy" | "balanced" | "hard" | "expert";

export type PuzzleDifficultyOption = {
  key: PuzzleDifficultyKey;
  label: string;
  description: string;
  ratingOffset: number;
  range: number;
};

export const PUZZLE_DIFFICULTY_STORAGE_KEY = "puzzle_difficulty";

export const PUZZLE_DIFFICULTY_OPTIONS: PuzzleDifficultyOption[] = [
  {
    key: "easy",
    label: "Easy",
    description: "Lower rated puzzles",
    ratingOffset: -250,
    range: 150,
  },
  {
    key: "balanced",
    label: "Balanced",
    description: "Around your rating",
    ratingOffset: 0,
    range: 125,
  },
  {
    key: "hard",
    label: "Hard",
    description: "Above your rating",
    ratingOffset: 300,
    range: 150,
  },
  {
    key: "expert",
    label: "Expert",
    description: "Far above your rating",
    ratingOffset: 600,
    range: 200,
  },
];

export function getPuzzleDifficultyOption(key: PuzzleDifficultyKey) {
  return (
    PUZZLE_DIFFICULTY_OPTIONS.find((option) => option.key === key) ||
    PUZZLE_DIFFICULTY_OPTIONS[1]
  );
}

export function isPuzzleDifficultyKey(
  value: unknown,
): value is PuzzleDifficultyKey {
  return PUZZLE_DIFFICULTY_OPTIONS.some((option) => option.key === value);
}

export function readPuzzleDifficulty(): PuzzleDifficultyKey {
  if (typeof window === "undefined") return "balanced";

  const storedDifficulty = window.localStorage.getItem(
    PUZZLE_DIFFICULTY_STORAGE_KEY,
  );

  return isPuzzleDifficultyKey(storedDifficulty)
    ? storedDifficulty
    : "balanced";
}

export function writePuzzleDifficulty(difficulty: PuzzleDifficultyKey) {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(PUZZLE_DIFFICULTY_STORAGE_KEY, difficulty);
}
